import { Fragment } from 'react';

import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import BpkMobileScrollContainer from '@skyscanner/backpack-web/bpk-component-mobile-scroll-container';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import ExpandableSection from '../../../ExpandableSection';
import ReviewImages from '../../ReviewImages';

import MiniReviewCard from './MiniReviewCard';
import ReviewsCustomizeMobile from './ReviewsCustomizeMobile';

import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

import STYLES from './ExpandableReviewsCustomizeMobile.module.scss';

import { useFirstReviews } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import { HASH_REVIEWS } from '@shared/constants/hash-routes';
import RouteLink, { withRouterLink } from '@shared/ui/common/RouteLink';
import { withI18n } from '@shared/ui/contexts/i18n';

const RouterReviewCard = withRouterLink(MiniReviewCard, HASH_REVIEWS);

type Props = {
  i18n: I18nService;
  reviewSummary: Nullable<HotelReviewSummary>;
};

const ExpandableReviewsCustomizeMobile = ({ i18n, reviewSummary }: Props) => {
  const firstReviews = useFirstReviews();

  return (
    <ExpandableSection
      href={HASH_REVIEWS}
      actionLabel={i18n.translate('Reviews_button_seeMore')}
      headline={i18n.translate('Hotel_review_title')}
      actionLinkClassName={
        STYLES.ExpandableReviewsCustomizeMobile__removePadding
      }
      contentClassName={STYLES.ExpandableReviewsCustomizeMobile__removePadding}
      viewportMoreContent={
        <ReviewsCustomizeMobile reviewSummary={reviewSummary} />
      }
    >
      <Fragment>
        <ReviewImages />
        <div className={STYLES.ExpandableReviewsCustomizeMobile__sectionHeader}>
          <BpkText textStyle={TEXT_STYLES.heading5}>
            {i18n.translate('Reviews_traveller_saying_label')}
          </BpkText>
          <RouteLink
            href={HASH_REVIEWS}
            render={(onClick, linkHref) => (
              <BpkLink href={linkHref ?? null} onClick={onClick}>
                {i18n.translate('Button_viewMore')}
              </BpkLink>
            )}
          />
        </div>
        <BpkMobileScrollContainer>
          <div
            className={
              STYLES.ExpandableReviewsCustomizeMobile__firstReviewsContainer
            }
          >
            {firstReviews.map((review) => (
              <RouterReviewCard
                key={`${review.partnerReviewId}-${review.partner}`}
                review={review}
              />
            ))}
          </div>
        </BpkMobileScrollContainer>
      </Fragment>
    </ExpandableSection>
  );
};

export default withI18n(ExpandableReviewsCustomizeMobile);
